import "./gallery.scss";
import { SetGallery } from "./imageViewer";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { GalleryList } from "../../services/data";
import { useNavigate } from "react-router-dom";
import { FaArrowCircleRight } from "react-icons/fa";
import { BackButton } from "../../components/Reusable/resuable";
import { allImages } from "../../services/images";
import { youtubevideos } from "../../services/data";
import { ImageGallery } from "../../services/DataFiles/Gallery/Imagegallery";
import YouTube from "react-youtube";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
function Gallery() {
    var navigate = useNavigate();
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    function nav(index = 0) {
        localStorage.setItem("gallery", index);
        navigate("/viewgallery");
    }
    return <div className="gallery">
        <Helmet>
            <title>Gallery - PBL Transport</title>
            <meta
                name="keywords"
                content="Trailers,Cranes,Axles,Forklifts,Manlifts"
            ></meta>
        </Helmet>
        <center><Heading heading="Gallery" lightMode={lightMode} /></center>
        <div className="categories">
            {GalleryList.map((item, i) =>
                <div key={i} className="cards" onClick={() => nav(i)}>
                    {item.images.map((image, i) => <img className={"part" + (i + 1)} src={image} alt="img" />)}
                    <div className="name">{item.name}<div className="more">View more&nbsp;<FaArrowCircleRight /></div></div>
                </div>
            )}
            <div key={"videos"} className="cards" onClick={() => navigate("/videos")}>
                <img className={"part1"} src={ImageGallery.cranes.ChainMountedCrawlerMountedCranes[0].image} alt="img" />
                <img className={"part2"} src={allImages.trailer} alt="img" />
                <img className={"part3"} src={allImages.forklift} alt="img" />
                <div className="name">Videos<div className="more">View more&nbsp;<FaArrowCircleRight /></div></div>
            </div>
        </div>
    </div>
}

function ViewGallery() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    var images = GalleryList[parseInt(localStorage.getItem("gallery"))];
    return <div className="viewgallery">
        <BackButton name="Back" />
        <center><Heading heading={images.name} lightMode={lightMode} /></center>
        {images.type.length > 0 ? images.type.map((item, i) => <SetGallery key={i} images={item.images} heading={item.heading} />) : <span />}
    </div>
}

function VideosList() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    const [loader, setLoader] = useState(true);
    return <div className="videos">
        <Heading heading="Videos" lightMode={lightMode} />
        {/* <div className="list mb-4">
            {
                videos.map((item, i) => <video key={i} controls width="320" height="240">
                    <source src={item.video} type="video/mp4" />
                </video>)
            }
        </div> */}
        <div className="list">
            {
                youtubevideos.map((item, i) => <div style={{ position: "relative" }}>
                    {loader && (<div className="youloader">
                        <div className="loader">Loading</div>
                    </div>)}
                    <YouTube videoId={item.video} opts={{ width: "320", height: "240" }} onReady={(e) => setLoader(false)} />
                </div>)
            }
        </div>
    </div>
}
export { Gallery, ViewGallery, VideosList }